import script from "./AuthBitrix24LoginButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthBitrix24LoginButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__